var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fetched)?_c('lgpd-terms',{attrs:{"loading":_vm.loading,"logo":_vm.logo},on:{"accept":_vm.accept,"refuse":_vm.refuse}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }